// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Disposition board (/user/dispatch) and "Mein Tag" (/user/my-day) */

.dispatch-page .dsp-full {
  width: 100%;
}

.dispatch-page .dsp-grow {
  flex: 1;
}

.dispatch-page .dsp-between {
  width: 100%;
  justify-content: space-between;
}

.dispatch-page .dsp-small {
  font-size: 12px;
  color: var(--ds-text-muted);
}

.dispatch-page .dsp-wrap,
.dispatch-page .dsp-pre {
  overflow-wrap: anywhere;
}

.dispatch-page .dsp-pre {
  white-space: pre-wrap;
}

.dispatch-page .dsp-section {
  margin-block-start: var(--ds-space-3, 12px);
}

.dispatch-page .dsp-source {
  margin-block-end: var(--ds-space-3, 12px);
}

/* Arrows point the other way in RTL */
[dir="rtl"] .dispatch-page .dsp-flip {
  transform: scaleX(-1);
}

.dispatch-page .dsp-drawer-footer {
  display: flex;
  gap: var(--ds-space-2, 8px);
  align-items: center;
}

/* ---- Conflicts ---- */

.dispatch-page .dsp-conflicts {
  list-style: none;
  margin: 0;
  padding: 0;
}

.dispatch-page .dsp-conflicts li {
  display: flex;
  gap: 6px;
  align-items: flex-start;
  padding-block: 2px;
  overflow-wrap: anywhere;
}

.dispatch-page .dsp-conflicts--compact li {
  font-size: 12px;
}

.dispatch-page .dsp-conflicts__warn {
  color: var(--ds-warning);
  margin-block-start: 3px;
}

.dispatch-page .dsp-conflicts__info {
  color: var(--ds-text-muted);
  margin-block-start: 3px;
}

.dispatch-page .dsp-badge {
  margin-inline-end: 0;
}

.dispatch-page .dsp-history {
  margin-block-start: var(--ds-space-3, 12px);
}

/* ---- Week grid ---- */

.dispatch-page .dsp-board {
  overflow-x: auto;
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
  background: var(--ds-surface);
}

.dispatch-page .dsp-week {
  display: grid;
  grid-template-columns: minmax(96px, 140px) repeat(var(--dsp-days, 7), minmax(128px, 1fr));
  min-width: min-content;
}

.dispatch-page .dsp-week__corner,
.dispatch-page .dsp-week__head {
  position: sticky;
  inset-block-start: 0;
  z-index: 2;
  background: var(--ds-surface-2);
  border-block-end: 1px solid var(--ds-border);
  padding: var(--ds-space-2, 8px);
  font-weight: 600;
}

.dispatch-page .dsp-week__corner {
  inset-inline-start: 0;
  z-index: 3;
}

.dispatch-page .dsp-week__head.dsp-today {
  color: var(--ds-brand);
  box-shadow: inset 0 -2px 0 var(--ds-brand);
}

.dispatch-page .dsp-holiday {
  background: var(--ds-warning-bg);
}

.dispatch-page .dsp-holiday__name {
  font-size: 11px;
  font-weight: 400;
  color: var(--ds-text-muted);
}

.dispatch-page .dsp-week__name,
.dispatch-page .dsp-day__name {
  position: sticky;
  inset-inline-start: 0;
  z-index: 1;
  background: var(--ds-surface);
  border-block-end: 1px solid var(--ds-border-soft);
  border-inline-end: 1px solid var(--ds-border-soft);
  padding: var(--ds-space-2, 8px);
  font-weight: 600;
  overflow-wrap: anywhere;
}

.dispatch-page .dsp-week__name--open {
  color: var(--ds-text-muted);
  font-style: italic;
}

.dispatch-page .dsp-cell {
  position: relative;
  min-height: 72px;
  padding: 4px;
  border-block-end: 1px solid var(--ds-border-soft);
  border-inline-end: 1px solid var(--ds-border-soft);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dispatch-page .dsp-cell--over {
  background: var(--ds-brand-50);
  outline: 2px dashed var(--ds-brand-400);
  outline-offset: -2px;
}

.dispatch-page .dsp-cell__add {
  align-self: flex-start;
  color: var(--ds-text-muted);
  min-height: 28px;
}

.dispatch-page .dsp-absence {
  margin-block: 0 2px;
  margin-inline: 0 4px;
}

/* ---- Cards ---- */

.dispatch-page .dsp-card {
  border: 1px solid var(--ds-border);
  border-inline-start: 4px solid var(--ds-brand);
  border-radius: var(--ds-radius-sm);
  background: var(--ds-surface);
  padding: 4px 6px;
  cursor: pointer;
  font-size: 12px;
  line-height: 1.35;
  box-shadow: var(--ds-shadow-xs);
}

.dispatch-page .dsp-card:focus-visible {
  outline: none;
  box-shadow: var(--ds-focus-ring);
}

.dispatch-page .dsp-card[draggable="true"] {
  cursor: grab;
}

.dispatch-page .dsp-card--maintenance {
  border-inline-start-color: var(--ds-success);
}

.dispatch-page .dsp-card--project {
  border-inline-start-color: var(--ds-brand-ink);
}

.dispatch-page .dsp-card--task {
  border-inline-start-color: var(--ds-brand-400);
}

.dispatch-page .dsp-card--appointment {
  border-inline-start-color: var(--ds-warning);
}

.dispatch-page .dsp-card__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
}

.dispatch-page .dsp-card__time {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

/* "08:00–10:00" reads left to right in RTL too */
.dispatch-page .dsp-card__time,
.dispatch-page .dsp-myjob__time {
  direction: ltr;
  unicode-bidi: isolate;
}

.dispatch-page .dsp-card__title {
  font-weight: 600;
  color: var(--ds-heading);
  overflow-wrap: anywhere;
}

.dispatch-page .dsp-card__meta {
  color: var(--ds-text-muted);
  overflow-wrap: anywhere;
}

.dispatch-page .dsp-travel {
  font-size: 11px;
  color: var(--ds-text-muted);
  padding-inline-start: 6px;
}

.dispatch-page .dsp-travel--tight {
  color: var(--ds-danger);
  font-weight: 600;
}

/* ---- Day timeline ---- */

.dispatch-page .dsp-day {
  display: grid;
  grid-template-columns: minmax(110px, 160px) minmax(720px, 1fr);
  min-width: min-content;
}

.dispatch-page .dsp-day__hours {
  position: relative;
  height: 32px;
  background: var(--ds-surface-2);
  border-block-end: 1px solid var(--ds-border);
}

.dispatch-page .dsp-day__hours span {
  position: absolute;
  inset-block-start: 8px;
  font-size: 11px;
  color: var(--ds-text-muted);
  padding-inline-start: 2px;
}

.dispatch-page .dsp-day__lane {
  position: relative;
  min-height: 76px;
  border-block-end: 1px solid var(--ds-border-soft);
}

.dispatch-page .dsp-day__tick {
  position: absolute;
  inset-block: 0;
  border-inline-start: 1px dashed var(--ds-border-soft);
}

.dispatch-page .dsp-day__block {
  position: absolute;
  inset-block-start: 4px;
  padding-inline-end: 2px;
}

.dispatch-page .dsp-day__block .dsp-card {
  height: 68px;
  overflow: hidden;
}

/* ---- Phones ---- */

.dispatch-page .dsp-mobile__days {
  margin-block-end: var(--ds-space-3, 12px);
}

.dispatch-page .dsp-mobile__days .ant-segmented-item-label {
  padding-inline: 2px;
  text-overflow: clip;
}

.dispatch-page .dsp-mobile__date {
  margin-block: 0 var(--ds-space-2, 8px);
}

.dispatch-page .dsp-today-text {
  color: var(--ds-brand);
  font-weight: 700;
}

.dispatch-page .dsp-mobile__group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-block: var(--ds-space-2, 8px);
  border-block-end: 1px solid var(--ds-border-soft);
}

.dispatch-page .dsp-mobile__name {
  font-weight: 600;
}

.dispatch-page .dsp-mobile .dsp-card {
  font-size: 14px;
  padding: 8px 10px;
  min-height: 44px;
}

.dispatch-page .dsp-quals {
  margin-block-end: 6px;
}

/* ---- Queue ---- */

.dispatch-page .dsp-queue__item[draggable="true"] {
  cursor: grab;
}

/* ---- Mein Tag ---- */

.dispatch-page.dsp-myday {
  max-width: 760px;
}

.dispatch-page .dsp-myday__bar {
  margin-block-end: var(--ds-space-3, 12px);
}

.dispatch-page .dsp-myday__who {
  width: 100%;
  max-width: 320px;
}

.dispatch-page .dsp-myday__day {
  margin-block-end: var(--ds-space-5, 20px);
}

.dispatch-page .dsp-myjob {
  margin-block-end: var(--ds-space-3, 12px);
  border-inline-start: 4px solid var(--ds-brand);
}

.dispatch-page .dsp-myjob__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dispatch-page .dsp-myjob__time {
  font-size: 18px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.dispatch-page .dsp-myjob__title {
  margin-block: 4px !important;
  overflow-wrap: anywhere;
}

.dispatch-page .dsp-myjob__row {
  margin-block-start: 6px;
  overflow-wrap: anywhere;
}

.dispatch-page .dsp-myjob__contact {
  display: flex;
  margin-block-start: 4px;
}

.dispatch-page .dsp-myjob__actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-space-2, 8px);
  margin-block-start: var(--ds-space-3, 12px);
}

@media (max-width: 767.98px) {
  .dispatch-page .dsp-myjob__actions > * {
    flex: 1 1 45%;
  }

  .dispatch-page .dsp-myday__bar,
  .dispatch-page .dsp-myday__bar .ant-space-item:first-child {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/dispatch/dispatch.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE;EACE,WAAW;AACb;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,sCAAsC;AACtC;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,wBAAwB;;AAExB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,wBAAwB;;AAExB;EACE,gBAAgB;EAChB,uCAAuC;EACvC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yFAAyF;EACzF,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,+BAA+B;EAC/B,4CAA4C;EAC5C,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,6BAA6B;EAC7B,iDAAiD;EACjD,kDAAkD;EAClD,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,iDAAiD;EACjD,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,oBAAoB;;AAEpB;EACE,kCAAkC;EAClC,8CAA8C;EAC9C,kCAAkC;EAClC,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,iDAAiD;AACjD;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,8DAA8D;EAC9D,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qBAAqB;;AAErB;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oBAAoB;;AAEpB;EACE,YAAY;AACd;;AAEA,uBAAuB;;AAEvB;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* Disposition board (/user/dispatch) and \"Mein Tag\" (/user/my-day) */\n\n.dispatch-page .dsp-full {\n  width: 100%;\n}\n\n.dispatch-page .dsp-grow {\n  flex: 1;\n}\n\n.dispatch-page .dsp-between {\n  width: 100%;\n  justify-content: space-between;\n}\n\n.dispatch-page .dsp-small {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n}\n\n.dispatch-page .dsp-wrap,\n.dispatch-page .dsp-pre {\n  overflow-wrap: anywhere;\n}\n\n.dispatch-page .dsp-pre {\n  white-space: pre-wrap;\n}\n\n.dispatch-page .dsp-section {\n  margin-block-start: var(--ds-space-3, 12px);\n}\n\n.dispatch-page .dsp-source {\n  margin-block-end: var(--ds-space-3, 12px);\n}\n\n/* Arrows point the other way in RTL */\n[dir=\"rtl\"] .dispatch-page .dsp-flip {\n  transform: scaleX(-1);\n}\n\n.dispatch-page .dsp-drawer-footer {\n  display: flex;\n  gap: var(--ds-space-2, 8px);\n  align-items: center;\n}\n\n/* ---- Conflicts ---- */\n\n.dispatch-page .dsp-conflicts {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.dispatch-page .dsp-conflicts li {\n  display: flex;\n  gap: 6px;\n  align-items: flex-start;\n  padding-block: 2px;\n  overflow-wrap: anywhere;\n}\n\n.dispatch-page .dsp-conflicts--compact li {\n  font-size: 12px;\n}\n\n.dispatch-page .dsp-conflicts__warn {\n  color: var(--ds-warning);\n  margin-block-start: 3px;\n}\n\n.dispatch-page .dsp-conflicts__info {\n  color: var(--ds-text-muted);\n  margin-block-start: 3px;\n}\n\n.dispatch-page .dsp-badge {\n  margin-inline-end: 0;\n}\n\n.dispatch-page .dsp-history {\n  margin-block-start: var(--ds-space-3, 12px);\n}\n\n/* ---- Week grid ---- */\n\n.dispatch-page .dsp-board {\n  overflow-x: auto;\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n  background: var(--ds-surface);\n}\n\n.dispatch-page .dsp-week {\n  display: grid;\n  grid-template-columns: minmax(96px, 140px) repeat(var(--dsp-days, 7), minmax(128px, 1fr));\n  min-width: min-content;\n}\n\n.dispatch-page .dsp-week__corner,\n.dispatch-page .dsp-week__head {\n  position: sticky;\n  inset-block-start: 0;\n  z-index: 2;\n  background: var(--ds-surface-2);\n  border-block-end: 1px solid var(--ds-border);\n  padding: var(--ds-space-2, 8px);\n  font-weight: 600;\n}\n\n.dispatch-page .dsp-week__corner {\n  inset-inline-start: 0;\n  z-index: 3;\n}\n\n.dispatch-page .dsp-week__head.dsp-today {\n  color: var(--ds-brand);\n  box-shadow: inset 0 -2px 0 var(--ds-brand);\n}\n\n.dispatch-page .dsp-holiday {\n  background: var(--ds-warning-bg);\n}\n\n.dispatch-page .dsp-holiday__name {\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--ds-text-muted);\n}\n\n.dispatch-page .dsp-week__name,\n.dispatch-page .dsp-day__name {\n  position: sticky;\n  inset-inline-start: 0;\n  z-index: 1;\n  background: var(--ds-surface);\n  border-block-end: 1px solid var(--ds-border-soft);\n  border-inline-end: 1px solid var(--ds-border-soft);\n  padding: var(--ds-space-2, 8px);\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.dispatch-page .dsp-week__name--open {\n  color: var(--ds-text-muted);\n  font-style: italic;\n}\n\n.dispatch-page .dsp-cell {\n  position: relative;\n  min-height: 72px;\n  padding: 4px;\n  border-block-end: 1px solid var(--ds-border-soft);\n  border-inline-end: 1px solid var(--ds-border-soft);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dispatch-page .dsp-cell--over {\n  background: var(--ds-brand-50);\n  outline: 2px dashed var(--ds-brand-400);\n  outline-offset: -2px;\n}\n\n.dispatch-page .dsp-cell__add {\n  align-self: flex-start;\n  color: var(--ds-text-muted);\n  min-height: 28px;\n}\n\n.dispatch-page .dsp-absence {\n  margin-block: 0 2px;\n  margin-inline: 0 4px;\n}\n\n/* ---- Cards ---- */\n\n.dispatch-page .dsp-card {\n  border: 1px solid var(--ds-border);\n  border-inline-start: 4px solid var(--ds-brand);\n  border-radius: var(--ds-radius-sm);\n  background: var(--ds-surface);\n  padding: 4px 6px;\n  cursor: pointer;\n  font-size: 12px;\n  line-height: 1.35;\n  box-shadow: var(--ds-shadow-xs);\n}\n\n.dispatch-page .dsp-card:focus-visible {\n  outline: none;\n  box-shadow: var(--ds-focus-ring);\n}\n\n.dispatch-page .dsp-card[draggable=\"true\"] {\n  cursor: grab;\n}\n\n.dispatch-page .dsp-card--maintenance {\n  border-inline-start-color: var(--ds-success);\n}\n\n.dispatch-page .dsp-card--project {\n  border-inline-start-color: var(--ds-brand-ink);\n}\n\n.dispatch-page .dsp-card--task {\n  border-inline-start-color: var(--ds-brand-400);\n}\n\n.dispatch-page .dsp-card--appointment {\n  border-inline-start-color: var(--ds-warning);\n}\n\n.dispatch-page .dsp-card__top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 4px;\n}\n\n.dispatch-page .dsp-card__time {\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n/* \"08:00–10:00\" reads left to right in RTL too */\n.dispatch-page .dsp-card__time,\n.dispatch-page .dsp-myjob__time {\n  direction: ltr;\n  unicode-bidi: isolate;\n}\n\n.dispatch-page .dsp-card__title {\n  font-weight: 600;\n  color: var(--ds-heading);\n  overflow-wrap: anywhere;\n}\n\n.dispatch-page .dsp-card__meta {\n  color: var(--ds-text-muted);\n  overflow-wrap: anywhere;\n}\n\n.dispatch-page .dsp-travel {\n  font-size: 11px;\n  color: var(--ds-text-muted);\n  padding-inline-start: 6px;\n}\n\n.dispatch-page .dsp-travel--tight {\n  color: var(--ds-danger);\n  font-weight: 600;\n}\n\n/* ---- Day timeline ---- */\n\n.dispatch-page .dsp-day {\n  display: grid;\n  grid-template-columns: minmax(110px, 160px) minmax(720px, 1fr);\n  min-width: min-content;\n}\n\n.dispatch-page .dsp-day__hours {\n  position: relative;\n  height: 32px;\n  background: var(--ds-surface-2);\n  border-block-end: 1px solid var(--ds-border);\n}\n\n.dispatch-page .dsp-day__hours span {\n  position: absolute;\n  inset-block-start: 8px;\n  font-size: 11px;\n  color: var(--ds-text-muted);\n  padding-inline-start: 2px;\n}\n\n.dispatch-page .dsp-day__lane {\n  position: relative;\n  min-height: 76px;\n  border-block-end: 1px solid var(--ds-border-soft);\n}\n\n.dispatch-page .dsp-day__tick {\n  position: absolute;\n  inset-block: 0;\n  border-inline-start: 1px dashed var(--ds-border-soft);\n}\n\n.dispatch-page .dsp-day__block {\n  position: absolute;\n  inset-block-start: 4px;\n  padding-inline-end: 2px;\n}\n\n.dispatch-page .dsp-day__block .dsp-card {\n  height: 68px;\n  overflow: hidden;\n}\n\n/* ---- Phones ---- */\n\n.dispatch-page .dsp-mobile__days {\n  margin-block-end: var(--ds-space-3, 12px);\n}\n\n.dispatch-page .dsp-mobile__days .ant-segmented-item-label {\n  padding-inline: 2px;\n  text-overflow: clip;\n}\n\n.dispatch-page .dsp-mobile__date {\n  margin-block: 0 var(--ds-space-2, 8px);\n}\n\n.dispatch-page .dsp-today-text {\n  color: var(--ds-brand);\n  font-weight: 700;\n}\n\n.dispatch-page .dsp-mobile__group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-block: var(--ds-space-2, 8px);\n  border-block-end: 1px solid var(--ds-border-soft);\n}\n\n.dispatch-page .dsp-mobile__name {\n  font-weight: 600;\n}\n\n.dispatch-page .dsp-mobile .dsp-card {\n  font-size: 14px;\n  padding: 8px 10px;\n  min-height: 44px;\n}\n\n.dispatch-page .dsp-quals {\n  margin-block-end: 6px;\n}\n\n/* ---- Queue ---- */\n\n.dispatch-page .dsp-queue__item[draggable=\"true\"] {\n  cursor: grab;\n}\n\n/* ---- Mein Tag ---- */\n\n.dispatch-page.dsp-myday {\n  max-width: 760px;\n}\n\n.dispatch-page .dsp-myday__bar {\n  margin-block-end: var(--ds-space-3, 12px);\n}\n\n.dispatch-page .dsp-myday__who {\n  width: 100%;\n  max-width: 320px;\n}\n\n.dispatch-page .dsp-myday__day {\n  margin-block-end: var(--ds-space-5, 20px);\n}\n\n.dispatch-page .dsp-myjob {\n  margin-block-end: var(--ds-space-3, 12px);\n  border-inline-start: 4px solid var(--ds-brand);\n}\n\n.dispatch-page .dsp-myjob__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.dispatch-page .dsp-myjob__time {\n  font-size: 18px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.dispatch-page .dsp-myjob__title {\n  margin-block: 4px !important;\n  overflow-wrap: anywhere;\n}\n\n.dispatch-page .dsp-myjob__row {\n  margin-block-start: 6px;\n  overflow-wrap: anywhere;\n}\n\n.dispatch-page .dsp-myjob__contact {\n  display: flex;\n  margin-block-start: 4px;\n}\n\n.dispatch-page .dsp-myjob__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2, 8px);\n  margin-block-start: var(--ds-space-3, 12px);\n}\n\n@media (max-width: 767.98px) {\n  .dispatch-page .dsp-myjob__actions > * {\n    flex: 1 1 45%;\n  }\n\n  .dispatch-page .dsp-myday__bar,\n  .dispatch-page .dsp-myday__bar .ant-space-item:first-child {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
